import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Ticket as Ticket23 } from 'projects/flow-gui-access/views/2.3/ticket'
import { Ticket as Ticket24 } from 'projects/flow-gui-access/views/2.4/ticket'

class Ticket extends Component {
  render () {
    if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'tickets' && endpoint.version === '2.4').length !== 0) {
      return <Ticket24 {...this.props} />
    } else if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'tickets' && endpoint.version === '2.3').length !== 0) {
      return <Ticket23 {...this.props} />
    } else return false
  }
}
export default connect(state => state)(Ticket)



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/middlewares/ticket/ticket.js